import { useBreadcrumbs } from '@shared/lib';
import { useEffect } from 'react';
import { CompanyBreadcrumbs, CompanyInfo } from '@features/company';
import { useGetCompany } from '@entities/company';
import { useParams } from 'react-router';
import { WithFallback } from '@shared/ui';

export const CompanyPage = () => {
  const { id } = useParams();

  const { data: company, isLoading } = useGetCompany(id || '');

  const context = useBreadcrumbs();

  useEffect(() => {
    if (!context) {
      return;
    }

    context.setBreadcrumb(<CompanyBreadcrumbs subPage={company?.name || ''} />);

    return () => {
      context.clearBreadcrumb();
    };
  }, [company?.name]);

  return (
    <WithFallback data={company} isLoading={isLoading}>
      {data => <CompanyInfo company={data} />}
    </WithFallback>
  );
};
